import React from "react";
import Albums from "../Albums/Albums";
import NoAlbums from "../Albums/NoAlbums";
import Loading from "../Albums/Loading";
import glamorous from "glamorous";

const ContentBlock = glamorous.div({
	display: 'flex',
	justifyContent: 'center'
});

const Content = ({ loading, albums, add, openEditModal }) => <ContentBlock>
	{ loading ? <Loading/> : (albums.length ? <Albums albums={albums} openEditModal={openEditModal}  /> : <NoAlbums add={add}/>) }
</ContentBlock>;

export default Content;
